var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"body-card overflow-hidden pa-0",attrs:{"fill-height":""}},[_c('div',{staticClass:"body-part px-0 px-md-0"},[_c('v-card',{staticClass:"ma-auto rounded-xl overflow-hidden body-temp",attrs:{"width":"100%"}},[_c('div',[_c('router-view')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }